import { Component, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, EventType, Router } from '@angular/router';
import { UserDropdownComponent } from '../../dropdowns/user-dropdown/user-dropdown.component';

@Component({
  selector: 'app-admin-navbar',
  standalone: true,
  // imports: [UserDropdownComponent],
  templateUrl: './admin-navbar.component.html',
  imports: [UserDropdownComponent],
})
export class AdminNavbarComponent implements OnInit {
  activatedRoute = inject(ActivatedRoute);

  currentRoute: string | null = null;

  constructor(private router: Router, private title: Title) {
    this.router.events.subscribe((route) => {
      if (route.type === EventType.NavigationEnd) {
        let segments: string[] = route.url.replace('/', '').split('/');
        segments = segments.map(
          (segment) => segment.charAt(0).toUpperCase() + segment.slice(1)
        );
        this.currentRoute = segments.join(' / ');
        // this.currentRoute = title.getTitle();
      }
    });
  }

  ngOnInit(): void {}
}
